import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import {
  TLPriority,
  TLSortDirection,
  TLWorkItemSortField,
  TLWorkItemStatus,
  TLWorkstream,
} from '@/api/gen/tessera-backend-api.schemas';
import { Worklist } from '@/components/features/worklist/Worklist';

const worklistSearchSchema = z.object({
  tab: z.enum(['All', 'My Tasks']).optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
  pageSize: z.number().int().min(1).max(100).optional().catch(undefined),
  status: z.array(z.nativeEnum(TLWorkItemStatus)).optional().catch(undefined),
  workstream: z.array(z.nativeEnum(TLWorkstream)).optional().catch(undefined),
  priority: z.array(z.nativeEnum(TLPriority)).optional().catch(undefined),
  assignee: z.string().optional().catch(undefined),
  sortBy: z.nativeEnum(TLWorkItemSortField).optional().catch(undefined),
  sortDir: z.nativeEnum(TLSortDirection).optional().catch(undefined),
});

export type WorklistSearch = z.infer<typeof worklistSearchSchema>;

export const Route = createFileRoute('/_protected/t/$tenantId/worklist')({
  component: Worklist,
  validateSearch: worklistSearchSchema,
});
